/**
 * The below file contains the constants used in the earthquake report.
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */

/**Constants for earthquake Listing page */
export const GET_ALL_EARTHQUAKE = "GET_ALL_EARTHQUAKE";
export const SET_EARTHQUAKE_LISTING = "SET_EARTHQUAKE_LISTING";
export const SET_EARTHQUAKE_LISTING_PARAM = "SET_EARTHQUAKE_LISTING_PARAM";
export const GET_EXPORT_EARTHQUAKE_DATA = "GET_EXPORT_EARTHQUAKE_DATA";
export const SET_EXPORT_EARTHQUAKE_DATA = "SET_EXPORT_EARTHQUAKE_DATA";
/**Constants for earthquake Listing page */

/**Constants for earthquake Import page */
export const EARTHQUAKE_IMPORT = "EARTHQUAKE_IMPORT";
/**Constants for earthquake Import page */

//#region All Section
/**Constants for all section details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_GET_ALL_SECTION = "EARTHQUAKE_GET_ALL_SECTION";
export const EARTHQUAKE_SET_ALL_SECTION = "EARTHQUAKE_SET_ALL_SECTION";
export const EARTHQUAKE_SET_RELIEF_CENTER_SECTION =
  "EARTHQUAKE_SET_RELIEF_CENTER_SECTION";
export const EARTHQUAKE_RESET_BUTTON_LOADING =
  "EARTHQUAKE_RESET_BUTTON_LOADING";
export const EARTHQUAKE_SET_PARENT_ID = "EARTHQUAKE_SET_PARENT_ID";
export const EARTHQUAKE_REPORT_SUBMIT = "EARTHQUAKE_REPORT_SUBMIT";
export const EARTHQUAKE_REPORT_DISCARD = "EARTHQUAKE_REPORT_DISCARD";
export const EARTHQUAKE_SET_REDIRECT_TO_LISTING =
  "EARTHQUAKE_SET_REDIRECT_TO_LISTING";
export const EARTHQUAKE_SET_DATA_SAVED = "EARTHQUAKE_SET_DATA_SAVED";
//#endregion All Section

//#region Basic Section
/**Constants for adding the basic section details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_BASIC_SECTION = "EARTHQUAKE_ADD_BASIC_SECTION";
export const EARTHQUAKE_EDIT_BASIC_SECTION = "EARTHQUAKE_EDIT_BASIC_SECTION";
export const EARTHQUAKE_SET_NIL_REPORTING = "EARTHQUAKE_SET_NIL_REPORTING";
//#endregion Basic Section

//#region InfDamage Section
/**Constants for adding the infrastructure damage details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_INFDAMAGE_SECTION =
  "EARTHQUAKE_ADD_INFDAMAGE_SECTION";
//#endregion InfDamage Section

//#region InfDamageOther Section
/**Constants for adding the infrastructure others damage details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_INFDAMAGEOTHER_SECTION =
  "EARTHQUAKE_ADD_INFDAMAGEOTHER_SECTION";
//#endregion InfDamageOther Section

//#region Remark Section
/**Constants for adding the Remark details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_REMARK_SECTION = "EARTHQUAKE_ADD_REMARK_SECTION";
//#endregion Remark Section

//#region PopAffected Section
/**Constants for adding the population affected details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-11-2022
 */
export const EARTHQUAKE_ADD_POPAFFECTED_SECTION =
  "EARTHQUAKE_ADD_POPAFFECTED_SECTION";
//#endregion PopAffected Section

//#region Eroded Section
/**Constants for adding the eroded details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_ERODED_SECTION = "EARTHQUAKE_ADD_ERODED_SECTION";
//#endregion Eroded Section

//#region Relief Camp Section
/**Constants for adding the relief camp details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_RELIEFCAMP_SECTION =
  "EARTHQUAKE_ADD_RELIEFCAMP_SECTION";
//#endregion relief camp Section

//#region Camp Inmates Section
/**Constants for adding the camp Inmates details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_CAMPINMATES_SECTION =
  "EARTHQUAKE_ADD_CAMPINMATES_SECTION";
//#endregion Camp Inmates Section

//#region Camp Non Inmates Section
/**Constants for adding the non camp Inmates details
 * @author: vishal.mishra@velsof.com
 * @date : 06-02-2025
 */
export const EARTHQUAKE_ADD_NONCAMPINMATES_SECTION =
  "EARTHQUAKE_ADD_NONCAMPINMATES_SECTION";
//#endregion Camp Inmates Section

//#region Human Live Lost Section
/**Constants for adding the Human Live Lost details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_HLL_SECTION = "EARTHQUAKE_ADD_HLL_SECTION";
//#endregion Human Live Lost Section

//#region LiveStock Section
/**Constants for adding the LiveStock details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_LIVESTOCK_SECTION =
  "EARTHQUAKE_ADD_LIVESTOCK_SECTION";
//#endregion LiveStock Section

//#region HouseDamaged Section
/**Constants for adding the HouseDamaged details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_HOUSEDAMAGED_SECTION =
  "EARTHQUAKE_ADD_HOUSEDAMAGED_SECTION";
//#endregion HouseDamaged Section

//#region RescueOperation Section
/**Constants for adding the RescueOperation details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_RESCUEOPERATION_SECTION =
  "EARTHQUAKE_ADD_RESCUEOPERATION_SECTION";
//#endregion RescueOperation Section

//#region ReliefDistribution Section
/**Constants for adding the ReliefDistribution details
 * @author: shivam.sharma2@velsof.com
 * @date : 21-12-2022
 */
export const EARTHQUAKE_ADD_RELIEFDISTRIBUTION_SECTION =
  "EARTHQUAKE_ADD_RELIEFDISTRIBUTION_SECTION";
//#endregion ReliefDistribution Section

/**
 * Constants for Reports and Approval and Disapproval
 * @author: neeraj.singh.rawat@velsof.com
 * @date : 28-12-2022
 */
//#region Report and Approval and Disapproval
export const EARTHQUAKE_REVENUE_REPORT_APPROVE =
  "EARTHQUAKE_REVENUE_REPORT_APPROVE";
export const EARTHQUAKE_REVENUE_REPORT_DISAPPROVE =
  "EARTHQUAKE_REVENUE_REPORT_DISAPPROVE";
export const EARTHQUAKE_REVENUE_REPORT_VERIFY =
  "EARTHQUAKE_REVENUE_REPORT_VERIFY";

export const EXPORT_FO_LEVEL_EARTHQUAKE_REPORT =
  "EXPORT_FO_LEVEL_EARTHQUAKE_REPORT";
export const SET_EXPORT_FO_LEVEL_EARTHQUAKE_REPORT =
  "SET_EXPORT_FO_LEVEL_EARTHQUAKE_REPORT";

export const EARTHQUAKE_DISTRICT_REPORT_APPROVE =
  "EARTHQUAKE_DISTRICT_REPORT_APPROVE";
export const EARTHQUAKE_DISTRICT_REPORT_DISAPPROVE =
  "EARTHQUAKE_DISTRICT_REPORT_DISAPPROVE";
export const EARTHQUAKE_DISTRICT_REPORT_VERIFY =
  "EARTHQUAKE_DISTRICT_REPORT_VERIFY";

export const EARTHQUAKE_STATE_REPORT_APPROVE =
  "EARTHQUAKE_STATE_REPORT_APPROVE";
export const EARTHQUAKE_STATE_REPORT_DISAPPROVE =
  "EARTHQUAKE_STATE_REPORT_DISAPPROVE";

export const GET_EARTHQUAKE_DISTRICT_REVIEW_LIST =
  "GET_EARTHQUAKE_DISTRICT_REVIEW_LIST";
export const SET_EARTHQUAKE_DISTRICT_REVIEW_LIST =
  "SET_EARTHQUAKE_DISTRICT_REVIEW_LIST";
export const GET_EARTHQUAKE_STATE_REVIEW_LIST =
  "GET_EARTHQUAKE_STATE_REVIEW_LIST";
export const SET_EARTHQUAKE_STATE_REVIEW_LIST =
  "SET_EARTHQUAKE_STATE_REVIEW_LIST";

export const SET_DISTRICT_EARTHQUAKE_REPORT = "SET_DISTRICT_EARTHQUAKE_REPORT";
export const GET_DISTRICT_EARTHQUAKE_REPORT = "GET_DISTRICT_EARTHQUAKE_REPORT";
export const GET_STATE_CUMULATIVE_EARTHQUAKE_REPORT =
  "GET_STATE_CUMULATIVE_EARTHQUAKE_REPORT";
export const SET_STATE_CUMULATIVE_EARTHQUAKE_REPORT =
  "SET_STATE_CUMULATIVE_EARTHQUAKE_REPORT";
export const GET_DISTRICT_CUMULATIVE_EARTHQUAKE_REPORT =
  "GET_DISTRICT_CUMULATIVE_EARTHQUAKE_REPORT";
export const SET_DISTRICT_CUMULATIVE_EARTHQUAKE_REPORT =
  "SET_DISTRICT_CUMULATIVE_EARTHQUAKE_REPORT";
//#region for storm form freeze unfreeze report for a selected Range
export const FREEZE_UNFREEZE_EARTHQUAKE_RANGE_REPORT =
  "FREEZE_UNFREEZE_EARTHQUAKE_RANGE_REPORT";
//#endregion Report and Approval and Disapproval
